VjsAdmin.TestingServersCreate = (function () {
    function init() {
        new Events();
    }

    let Events = VjsUtility.Controller.extend({
        btn: null,
        events: {
            'click .create-server': 'createServer',
        },
        createServer() {
            this.startLoadingButton();

            const data = {};
            data.description = $.trim($('#description').val());
            data.ticket = $.trim($('#ticket').val());
            data.dns = $.trim($('#dns').val());
            data.clone_flag = $.trim($('#clone_flag').val());
            data.bypass_sleep_mode = $.trim($('#bypass_sleep_mode').val());
            data.ssh_flag = $.trim($('#ssh_flag').val());
            data.sentry_dns = $.trim($('#sentry_dns').val());
            data.daily_snapshot_flag = $.trim($('#daily_snapshot_flag').val());

            if (data.description === '') {
                this.stopLoadingButton();
                return VjsUtility.Notification.error({
                    text: '`Server Name` is required',
                    time: 4000,
                });
            }
            if (data.ticket === '') {
                this.stopLoadingButton();
                return VjsUtility.Notification.error({
                    text: '`JIRA Ticket` is required',
                    time: 4000,
                });
            }
            if (data.dns === '') {
                data.dns = data.ticket;
            }

            const req = new VjsUtility.Request();
            req.post('/api/servers/', data)
                .done(() => {
                    window.location.href = '/admin/testing-servers/';
                })
                .fail((x, h, r) => {
                    this.stopLoadingButton();
                    console.log(x, h, r);
                    VjsUtility.Notification.error({
                        text: 'Error - look in console',
                        time: 4000,
                    });
                });
        },
        startLoadingButton() {
            this.btn = $('.create-server');
            this.btn.text('Creating...');
            this.btn.prop('disabled', true);
        },
        stopLoadingButton() {
            this.btn.text('Create Server');
            this.btn.prop('disabled', false);
        },
    });

    return {
        init,
    };
}());
